/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {Popover, Modal, Divider, Tabs, Radio, Input, Upload, message, Button, Dropdown,Space} from "antd";
import {API, history, prefix, imgRoot, IconFont, ROOT} from "./static/js/common";
import {CloseOutlined, DoubleRightOutlined, DoubleLeftOutlined, FormOutlined, PlusOutlined,DownCircleOutlined,UserOutlined,PoweroffOutlined} from "@ant-design/icons";
import moment from "moment";
import eventBus from "./static/js/events";
import { withRouter } from 'react-router-dom';
import { CustomerServiceOutlined,WechatWorkOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
const { TextArea } = Input;
export const LoginContext = React.createContext();

const content = (
  <div style={{fontWeight: 'bold'}}>
    <div>
      <IconFont
        type="icon-kefu"
        style={{fontSize: 15, color: "#33AAFF",marginRight: 4}}
      />
      山治
      <span style={{fontSize: 12, color: "#b8becc"}}>（微信和电话同号）</span>
    </div>
  
  </div>
)

const items = [
  {
    key: '1',
    label: (
      <span></span>
    ),
  },
]

// 文件格式大小验证
function beforeUpload(file) {
  /*   const isFile = /csv|excel|sheet/g.test(file.type);
  if (!isFile) {
    message.error("仅支持CSV、XLSX、XLS格式的文件！");
  } */
  const isLt1M = file.size / 1024 / 1024 < 10;
  if (!isLt1M) {
    message.error("上传的文件不能大于10MB!");
  }
  return isLt1M;
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLogin: false, // 是否登录
      phone: "",
      tabKey: "",
      isShow: false,
      isShowPlugin: false,
      isShowWeb: false,
      isShowkf: false,
      isShowFeed: false,
      isShowwx: false,
      isShowVideo: false,
      isShowBanner: false,
      isShowDiv: true,
      video_url: '',
      video_title: '',
      plugin_url: 'https://cdn.abc11223.com/source/daifa/video/plugin_video.mp4',
      web_url: 'https://cdn.abc11223.com/source/daifa/video/webp_video.mp4',
      contextValue: { isLogin: 0 },
      logo: "require('../../assets/home.png')",
      isShowFeedModal: false,
      feedType: 1,
      feedContent: '',
      fileList: [],
      key: '1'
    };
  }

  componentDidMount() {
    //第一次进入网页弹窗
    /* let isShow = false;
    if (!window.localStorage.getItem("LP-ISFIRST")) {
      isShow = true;
      window.localStorage.setItem("LP-ISFIRST", 1);
    }
    this.setState({ isShow }); */
    
    this.getUserInfo();
    this.getTabKey();
    let fr = this.getUrlParams ('fr',window.location.search || window.location.hash);
    let inviteCode = this.getUrlParams ('inviteCode',window.location.search || window.location.hash);
    if(fr === 'baidu'){
      fr = 2;
    } else if(fr === 'ddd'){
      fr = 0;
    } else{
      fr = 1;
    }
    window.localStorage.setItem("from-origin", fr);
    if(inviteCode) {
      window.localStorage.setItem("invite-code", inviteCode);
    }else{
      window.localStorage.removeItem('invite-code')
    }


    let params = window.location.search || window.location.hash;
    if(params.includes('#/')) {
      params = params.split('#/')[1]
    }
    let isShow = this.getUrlParams ('show',params);
    if(isShow) {
      this.setState({isShowVideo: true, video_url: "https://cdn.abc11223.com/source/daifa/video/pdd_daifa.mp4", video_title: '插件版教程', key: '2'})
    }else{
      const show = window.localStorage.getItem("showBanner");
      const todayDate = window.localStorage.getItem("showBannerDate");
      const nowDate = moment().format("YYYY-MM-DD");
      if(!show && !todayDate) {
        this.setState({isShowBanner: true});
        window.localStorage.setItem("showBanner", '1');
        window.localStorage.setItem("showBannerDate", nowDate);
      }
      if(parseInt(show) || (todayDate && (Date.parse(nowDate) - Date.parse(todayDate))/(24*60*60*1000) >= 3)){
        this.setState({isShowBanner: true});
        window.localStorage.setItem("showBanner", '1');
        window.localStorage.setItem("showBannerDate", nowDate);
      }
    }
  }

  getUrlParams = (name, str) => {
    const reg = new RegExp(`(^|&)${ name}=([^&]*)(&|$)`);
    const r = str.substr(1).match(reg);
    if (r != null) return  decodeURIComponent(r[2]); return null;
  };

  componentWillReceiveProps(props) {
    const path = props.location.pathname;
    if (path.indexOf("seller") !== -1) {
      if (this.state.isLogin || path.indexOf("help") !== -1) {
        this.setState({ tabKey: "seller" });
      } else {
        this.setState({ tabKey: "login" });
        this.props.history.push("/login?tabKey=login");
      }
    } else if (path === "/") {
      this.getUserInfo();
      this.getTabKey();
    } else {
      this.getTabKey();
    }
  }

  getUserInfo = () => {
    API.getAuthInfo({}).then((res) => {
      if (res.status * 1 === 0) {
        this.setState({
          isLogin: true,
          phone: res.extData.mobile,
          contextValue: { isLogin: 1 },
        });
        window.localStorage.setItem("phone", res.extData.mobile);
        // window.localStorage.setItem("dfToken", res.extData.token);
        // setCookie("dfToken", res.extData.token, ".abc11223.com");
      } else if (res.status * 1 === 1000) {
        this.setState({
          isLogin: false,
          contextValue: { isLogin: 0 },
        });
        window.localStorage.setItem("phone", "");
        if (
          this.props.location.pathname.indexOf("seller") !== -1 &&
          this.props.location.pathname.indexOf("help") === -1
        ) {
          this.props.history.push("/login?tabKey=login");
        }
      }
    });
  };

  getTabKey = () => {
    const params = window.location.hash;
    if (params.indexOf("seller") !== -1) {
      this.setState({ tabKey: "seller" });
    } else if (
      params.indexOf("login") !== -1 ||
      params.indexOf("forget") !== -1 ||
      params.indexOf("register") !== -1
    ) {
      this.setState({ tabKey: "login" });
    } else if(params.indexOf("collect") !== -1) {
      this.setState({ tabKey: "collect" });
    } else if(params.indexOf("help") !== -1) {
      this.setState({ tabKey: "help" });
    }
    else{
      this.setState({ tabKey: "all" });
    }
  };

  handleLogout = () => {
    API.getLogin({}).then((res) => {
      if (res.status * 1 === 0) {
        this.setState({ isLogin: false });
        window.localStorage.setItem("dfToken", "");
        // 清空律师信息缓存
        window.localStorage.removeItem('lawyer');
        this.props.history.push("/?tabKey=all");
        window.location.reload();
      }
    });
  };

  handleChangeTab = (url) => {
    if (this.state.isLogin) {
      this.setState({ tabKey: "seller" });
      this.props.history.push(url);
    } else {
      this.setState({ tabKey: "login" });
      this.props.history.push("/login?tabKey=login");
    }
  };

  handleCollectTab = (url) => {
    if (this.state.isLogin) {
      this.setState({ tabKey: "collect" });
      this.props.history.push(url);
    } else {
      this.setState({ tabKey: "login" });
      this.props.history.push("/login?tabKey=login");
    }
  };

  handleHelpTab = (url) => {
    if (this.state.isLogin) {
      this.setState({ tabKey: "help" });
      this.props.history.push(url);
    } else {
      this.setState({ tabKey: "login" });
      this.props.history.push("/login?tabKey=login");
    }
  };

  linkWuliuPath = () => {
    if(this.props.location.pathname.indexOf("help") === -1){
      this.handleHelpTab("/help?path=express")
    }else{
      eventBus.emit('changeHelpType')
    }
  };

  content = (url) => {
    return (
      <div style={{minHeight: 128}}>
        {/* <img src={`${imgRoot}/${url}`} alt="" width="100px" /> */}
        {/* <img src={`require("./assets/${url}")`} alt="" width="100px" /> */}
        <img src={require("./assets/code.png")} alt="" width="100px" />
        <div style={{ textAlign: "center", marginTop: 6 }}>扫码联系客服</div>
      </div>
    );
  };

  contentCode = (url) => {
    return (
      <div style={{minHeight: 128}}>
        {/* <img src={`${imgRoot}/${url}`} alt="" width="100px" /> */}
        {/* <img src={`require("./assets/${url}")`} alt="" width="100px" /> */}
        <img src={require("./assets/code2.png")} alt="" width="100px" />
        <div style={{ textAlign: "center", marginTop: 6 }}>扫码联系客服</div>
      </div>
    );
  };

  title = (title) => {
    return (
      <span>
        {title}
        {title.includes('插件') ? (
            <span style={{marginLeft: 10, color: '#66BFFF',fontWeight: 'bold', cursor: 'pointer'}}
                  onClick={() => window.open('https://abc11223.com/help.html','_blank')}
            >插件下载</span>
        ) : ''}
      </span>
    );
  };

  closeBanncer = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({isShowBanner: false});
    window.localStorage.setItem("showBanner", '0');
  };

  hideDiv = () => {
    this.setState({isShowDiv: false})
  };
  showDiv = () => {
    this.setState({isShowDiv: true})
  };

  onTabChange = (e) => {
    this.setState({key: e})
    if(e == 2) {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'home', 'video_plugin', 'pdd'])
      }
      this.setState({video_url: "https://cdn.abc11223.com/source/daifa/video/pdd_daifa.mp4"})
    } else if(e == 1) {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'home', 'video_plugin', 'taobao'])
      }
      this.setState({video_url: "https://cdn.abc11223.com/source/daifa/video/plugin_video.mp4"})
    } else {
      if (window._hmt) {
        window._hmt.push(['_trackEvent', 'home', 'video_plugin', 'dfbgfh'])
      }
      this.setState({video_url: "https://cdn.abc11223.com/source/daifa/video/dfbgfh.mp4"})
    }
  }

  // 上传文件
  handleChange = ({ fileList }) => {
    const file = fileList.map(iterator => {
      if (iterator.status === 'done' && iterator.response.extData) {
        iterator.url = iterator.response.extData.fileUrl;
      }
      return iterator;
    });
    this.setState({fileList: file})
  };

  handleSubmit = () => {
    const { feedType, feedContent, fileList} = this.state;
    const self = this;
    if (!feedContent) {
      message.error("请输入问题描述");
      return;
    }
    const reqData = {
      type: feedType,
      content: feedContent,
      attach: fileList.length ? fileList.map(item => item.url).join(',') : ""
    };
    API.postSubmitFeed(reqData).then((res) => {
      if (res.status * 1 === 0) {
        message.success("提交成功");
        self.setState({
          feedType: 1,
          feedContent: "",
          fileList: [],
          isShowFeedModal: false
        });
      } else {
        message.error(res.message || "提交失败！");
      }
    });
  };

  render() {
    const { logo, isLogin, phone, tabKey, isShow, contextValue, isShowPlugin, isShowWeb,
      isShowkf,isShowwx, isShowVideo, video_url, plugin_url, web_url, video_title, isShowBanner,
      isShowDiv, isShowFeed, isShowFeedModal, feedType, feedContent, fileList, key } = this.state;

    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>上传图片</div>
      </div>
    );

    return (
      <div>
        {/* <div className="common_head">
          <div className="box flex-space">
            <ul className="flex-space">
              <li id="collect">
                <img
                  alt=""
                  src={`${imgRoot}/shoucang.png`}
                />
                收藏本站
                <div className="collect_show">Ctrl+D 收藏本站</div>
              </li>
              <li style={{ padding: 0 }}>
                <b>/</b>
              </li>
              <li>网站导航</li>
            </ul>
            <ul className="flex-space">
              {isLogin ? (
                <Fragment>
                  欢迎您：
                  <li id="is_login">
                    <span style={{ color: "#FF3333" }}>{phone}</span>
                    <span
                      style={{ marginLeft: 10 }}
                      onClick={this.handleLogout}
                    >
                      退出
                    </span>
                  </li>
                </Fragment>
              ) : (
                <li id="common_log" style={{ color: "#ff3333" }}>
                  欢迎访问
                </li>
              )}
              <li style={{ padding: 0 }}>
                <b>/</b>
              </li>
              <li>帮助中心</li>
              <li style={{ padding: 0 }}>
                <b>/</b>
              </li>
              <Popover
                placement="bottom"
                content={this.content}
                trigger="hover"
              >
                <li>联系客服</li>
              </Popover>
            </ul>
          </div>
        </div> */}
        {/*<div*/}
        {/*  className="home_banner_model"*/}
        {/*  onClick={() => {*/}
        {/*    window.open("https://www.jmabc.com/?fr=xtdf");*/}
        {/*  }}*/}
        {/*></div>*/}
        {/* {isShowBanner && (
          <div className="home_header_top" onClick={(_) => this.linkWuliuPath()}>
            <span onClick={this.closeBanncer}><CloseOutlined /></span>
          </div>
        )} */}
        <div style={{ minWidth: 1200, background: "#ffffff" }}>
          <div style={{minWidth:120}}></div>
          <div className="home_header flex-start" style={{ minWidth: 1400 }}>
            <div className="home_header_name" style={{marginRight:30}}>
              <Link to="/?tabKey=all">
                <img
                  // src={`imgRoot/source/daifa/${
                  //   prefix ? "abc11223logo" : "text"
                  // }.svg`}
                  // src={logo}
                  src={require("./assets/logo2.png")}
                  style={{width:'230px',height:'34px'}}
                  alt=""
                  onClick={(_) => this.setState({tabKey: "all"})}
                />
              </Link>
            </div>
            <div className="flex-start" style={{position: 'relative',width:'100%'}}>
              {/*  <Link to="/">
              <div
                className={`home_header_tab ${
                  tabKey === "home" ? "active_tab" : ""
                }`}
              >
                首页
              </div>
            </Link> */}
              <Link to="/?tabKey=all">
                <div
                  className={`home_header_tab ${
                    tabKey === "all" ? "active_tab" : ""
                  }`}
                  onClick={(_) => this.setState({ tabKey: "all" })}
                >
                  所有商品
                </div>
              </Link>
              {/* <div
                className={`home_header_tab ${
                  tabKey === "seller" ? "active_tab" : ""
                  }`}
                onClick={(_) => this.handleChangeTab("/seller/account/home")}
              >
                个人中心
              </div> */}
              <div className='home_header_tab' onClick={() => {window.open("https://duoduolang.com/");}}>拼多多运营插件</div>
              <div
                className={`home_header_tab ${
                  tabKey === "collect" ? "active_tab" : ""
                  }`}
                onClick={(_) => this.handleCollectTab("/collect?tabKey=collect")}
              >
                我的收藏
              </div>
              <div
                className={`home_header_tab ${
                  tabKey === "help" ? "active_tab" : ""
                  }`}
                onClick={(_) => this.handleHelpTab("/help")}
              >
                {/* <span style={{display:'block'}}>上海正策（杭州）律所</span>  */}
                <span style={{display:'block',textAlign:'center'}}>方丽莎律师公益</span>
              </div>
              {/*<Link to="/collect?tabKey=collect">*/}
              {/*  <div*/}
              {/*    className={`home_header_tab ${*/}
              {/*      tabKey === "collect" ? "active_tab" : ""*/}
              {/*      }`}*/}
              {/*    onClick={(_) => this.setState({tabKey: 'collect'})}>*/}
              {/*    收藏列表*/}
              {/*  </div>*/}
              {/*</Link>*/}
              <Popover
                placement="bottom"
                content={() => this.content("code.png")}
                trigger="hover"
              >
                <div className="home_header_tab">联系客服</div>
              </Popover>
              <Popover
                placement="bottom"
                content={() => this.contentCode("code2.png")}
                trigger="hover"
              >
                <div
                  className="home_header_tab"
                  // style={{ marginRight: isLogin ? 120 : 250 }}
                >
                  供货商入驻
                </div>
              </Popover>
            {/*</div>*/}
            {/*<div*/}
            {/*  className="jmabc_banner"*/}
            {/*  style={{color: '#c99a0e', cursor: 'pointer'}}*/}
            {/*  onClick={() => {*/}
            {/*    window.open("https://www.jmabc.com/?fr=xtdf");*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <img*/}
            {/*    style={{marginRight: '3px'}}*/}
            {/*    src='https://img.jmabc.com/common/logo/24.png'*/}
            {/*    alt=''/>*/}
            {/*  <span style={{verticalAlign: 'middle'}}>jmabc买家秀平台</span>*/}
            {/*</div>*/}
            {/*<div className="home_login">*/}
              {isLogin ? (
                <div style={{ fontSize: 14, padding: "6px 0", position: 'absolute', right: 0,color:'#33aaff' }}>
                  {/* <span
                    className="home_header_tab_logout"
                    onClick={this.handleLogout}
                  >
                    退出
                  </span> */}
                  <Dropdown
                    menu={{ items: [] }}
                    dropdownRender={() => (
                      <div 
                        className="ant-dropdown-menu"
                        style={{width: '180px',height:'144px',borderRadius: '10px',padding:'15px 20px'}}
                      > {/* ✅ 关键类名 */}
                        <div 
                          style={{ fontSize:16,fontWeight:'bold',color:'#33aaff'}}
                        >
                          {phone}
                        </div>
                        <div style={{width:'140px',height:'1px',background: '#f0f2f5',margin:"15px 0"}}></div>
                        <div style={{height:'35px',color: '#33aaff',cursor: 'pointer'}} onClick={(_) => this.handleChangeTab("/seller/account/home")}><UserOutlined /> &nbsp;个人中心</div>
                        <div style={{height:'35px',color: '#45474d',cursor: 'pointer'}} onClick={this.handleLogout}><PoweroffOutlined /> &nbsp;退出登录</div>
                      </div>
                    )}
                  >
                   <a onClick={e => e.preventDefault()}>
                     <Space style={{fontSize: 14,color:'#33aaff'}}>
                       欢迎您! <span style={{ fontWeight:'bold' }}> {phone}</span>
                       <DownCircleOutlined style={{color:'rgb(124 132 132)'}}/>
                     </Space>
                   </a>
                 </Dropdown>
                </div>
              ) : (
                <Link to="/login?tabKey=login">
                  <div
                    // className={`home_header_tab ${
                    //   tabKey === "login" ? "active_tab" : ""
                    //   }`}
                    style={{ marginRight: 0 ,marginLeft:400}}
                    // onClick={(_) => this.setState({ tabKey: "login" })}
                  >
                    <Button 
                      type="primary" 
                      style={{width:'96px',height:'34px'}} 
                      onClick={(_) => this.setState({ tabKey: "login" })}>
                        登录
                    </Button>
                  </div>
                </Link>
              )}
            </div>
          </div>
        </div>
        <LoginContext.Provider value={contextValue}>
          {this.props.children}
        </LoginContext.Provider>
        {isShowDiv && (
          <div className="fix_icon_wrapper">
            <div id="btnOnlineService" className="kefu_online">
              {/* <Popover
                content="点击咨询客服"
                placement="left"
                trigger="hover">
                <img src="https://images.weserv.nl/?url=https://cdn.abc11223.com/source/daifa/service_online.png"/>
              </Popover> */}
              {/* <img src={require('./assets/kefu.png')}/> */}
            </div>

            {/* <div className="icon_bg"> */}
              {/* <div className="hide" title="收起" onClick={this.hideDiv}>
                <DoubleRightOutlined/>
              </div> */}

              {/* {!isShowWeb && (
                <div className="web_icon"
                     style={{paddingTop: 8}}
                     onMouseEnter={(_) => this.setState({isShowWeb: true})}>
                  <IconFont
                    type="icon-wangye1"
                    style={{fontSize: 26, color: "#ffffff"}}
                  />
                </div>)}
                {isShowWeb && (
                <div className="kf_wechat flex-center"
                style={{marginTop: 4, backgroundColor: "#ffffff", cursor: 'pointer', color: '#33AAFF'}}
                onMouseLeave={(_) => this.setState({isShowWeb: false})}>
                  网页
                </div>)} */}
            {/* </div> */}

            <div className="icon_contact" style={{marginTop: 6}}>
              {!isShowwx && (
                <div className="kf_wechat flex-center"
                     style={{marginTop: 4}}
                     onMouseEnter={(_) => this.setState({isShowwx: true})}>
                  {/* <IconFont
                    type="icon-a-wx2x"
                    style={{fontSize: 26, color: "#ffffff"}}
                  /> */}
                  {/* <CustomerServiceOutlined style={{fontSize: 26, color: "#ffffff"}}/> */}
                  <WechatWorkOutlined style={{fontSize: 26, color: "#ffffff"}}/>
                </div>)}
              {isShowwx && (
                <div className="kf_wechat flex-center"
                     style={{marginTop: 4, backgroundColor: "#ffffff", cursor: 'pointer', color: '#33AAFF'}}
                     onMouseLeave={(_) => this.setState({isShowwx: false})}>
                  <Popover
                    placement="left"
                    content={() => this.content("code.png")}
                    trigger="hover">
                    客服
                  </Popover>
                </div>
              )}
              {/*<div className="line"></div>*/}
              {/*{!isShowkf && (*/}
              {/*  <div className="kf_icon flex-center"*/}
              {/*       onMouseEnter={(_) => this.setState({isShowkf: true})}>*/}
              {/*    <IconFont*/}
              {/*      type="icon-kefu"*/}
              {/*      style={{fontSize: 26, color: "#ffffff"}}*/}
              {/*    />*/}
              {/*  </div>)}*/}
              {/*{isShowkf && (*/}
              {/*  <div className="kf_icon flex-center"*/}
              {/*       style={{backgroundColor: "#ffffff", cursor: 'pointer', color: '#33AAFF'}}*/}
              {/*       onMouseLeave={(_) => this.setState({isShowkf: false})}>*/}
              {/*    <Popover*/}
              {/*      content={content}*/}
              {/*      placement="left"*/}
              {/*      trigger="hover">*/}
              {/*      客服*/}
              {/*    </Popover>*/}
              {/*  </div>)}*/}
              <div className="line"></div>
              {!isShowFeed && (
                <div className="kf_icon flex-center"
                     onMouseEnter={(_) => this.setState({isShowFeed: true})}>
                  <FormOutlined style={{fontSize: 26, color: "#ffffff"}}/>
                </div>)}
              {isShowFeed && (
                <div className="kf_icon flex-center"
                     style={{backgroundColor: "#ffffff", cursor: 'pointer', color: '#33AAFF'}}
                     onMouseLeave={(_) => this.setState({isShowFeed: false})}
                     onClick={() => this.setState({isShowFeedModal: true})}>
                    反馈
                </div>)}
            </div>
          </div>
        )}
        {!isShowDiv && (
          <div className="fix_icon_show_wrapper" onClick={this.showDiv}>
            <div className="show_icon" title="展开">
              <DoubleLeftOutlined />
            </div>
          </div>
        )}
        <div className="common_footer">
          <Divider plain>严正声明</Divider>
          <div className="footer_desc">
            <div className="flex-start">
              <div className="index flex-center">1</div>
              <div className="desc">本站为正规礼品批发商城，类似1688平台，不提供信封、空包等违法服务，严禁用于刷单、洗钱行为！</div>
            </div>
            <div className="flex-start">
              <div className="index flex-center">2</div>
              <div className="desc">严禁张冠李戴，非法使用他人个人信息用于犯罪，一经发现，直接封号，并保存记录协助公安机关调查！</div>
            </div>
            <div className="flex-start">
              <div className="index flex-center">3</div>
              <div className="desc">平台账户仅限于自己使用，严禁非法牟利注册/倒卖账号行为，违规者双方均须承担相应法律责任！</div>
            </div>
            <div className="flex-start">
              <div className="index flex-center">4</div>
              <div className="desc">严禁通过平台获取快递单号后到第三方电商平台店铺进行退货退款行为，违规者直接封号且须承担相应法律责任！</div>
            </div>
          </div>
          <div className="footer_href">
          {/* http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=123 */}
            <a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_blank"
              style={{marginRight: '20px'}}>
              {/* 浙公网安备123123号&nbsp; */}
              {/* {prefix ? "浙ICP备123123号-7" : "浙ICP备123123号-1"} */}
              {prefix ? "浙ICP备123123号-7" : "湘ICP备2024071522号-1"}
            </a>
            {/* <a href="https://beian.miit.gov.cn" target="_blank">
              增值电信业务经营许可证：
              {prefix ? "浙B2-123123" : "浙B2-123123"}
            </a> */}
          </div>
        </div>
        <Modal
          open={isShow}
          footer={null}
          onCancel={(_) => this.setState({ isShow: false })}
          className="modal_first"
        >
          <div className="modal_code">
            {/* <img src={`${imgRoot}/dfcode.png`} alt="" /> */}
            <img src={require("./assets/code.png")} alt="" />
          </div>
          <div>扫码添加管理员</div>
          <div>礼品问题24小时在线回复</div>
        </Modal>
        <Modal
          open={isShowVideo}
          footer={null}
          width="1100px"
          title={this.title(video_title)}
          onCancel={(_) => this.setState({ isShowVideo: false, video_url: '', key: '1' })}
          className="modal_video">
          {video_title.includes('插件') ? (
            <div className="tab_wrapper">
              <Tabs onChange={ e => this.onTabChange(e)} activeKey={key}>
                <Tabs.TabPane tab="淘宝版" key="1"></Tabs.TabPane>
                <Tabs.TabPane tab="拼多多版" key="2"></Tabs.TabPane>
                <Tabs.TabPane tab="发货助手" key="3"></Tabs.TabPane>
              </Tabs>
            </div>
          ) : ''}
          <div className="video_wrapper">
            <video src={video_url} autoPlay muted controls="controls" width="1050" height="600"/>
          </div>
        </Modal>
        <Modal
          open={isShowFeedModal}
          footer={null}
          width="600px"
          title="意见反馈"
          onCancel={(_) => this.setState({ isShowFeedModal: false })}
          className="modal_feed"
          >
          <div className="form_wrapper">
            <div className="flex-start" style={{marginBottom: 14}}>
              <div style={{width: '70px'}}>反馈类型</div>
              <div>
               <Radio.Group
                value={feedType}
                buttonStyle="solid"
                onChange={(e) => this.setState({ feedType: e.target.value })}>
                <Radio.Button value={1} style={{borderRadius: 5,marginRight:10,border: '1px solid #fff'}}>bug反馈</Radio.Button>
                <Radio.Button value={2} style={{borderRadius: 5,marginRight:10,border: '1px solid #fff'}}>功能建议</Radio.Button>
                <Radio.Button value={3} style={{borderRadius: 5,marginRight:10,border: '1px solid #fff'}}>投诉客服</Radio.Button>
                <Radio.Button value={4} style={{borderRadius: 5,marginRight:10,border: '1px solid #fff'}}>订单问题</Radio.Button>
                <Radio.Button value={5} style={{borderRadius: 5,marginRight:10,border: '1px solid #fff'}}>其它</Radio.Button>
               </Radio.Group>
              </div>
            </div>
            <div className="flex-start" style={{marginBottom: 14}}>
              <div style={{width: '70px'}}>反馈描述</div>
              <div>
              <TextArea
                className="input_desc"
                value={feedContent}
                style={{width: 450,borderRadius:6,border:'1px solid #fff'}}
                max={200}
                onChange={(e) => this.setState({feedContent: e.target.value})}
                autoSize={{minRows: 4}}
                placeholder="请输入问题"/>
              </div>
            </div>
            <div className="flex-start">
              <div style={{width: '70px'}}>反馈附件</div>
              <div className="flex-start">
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  style={{fontSize: 12,color:'#33aaff',background: '#ffffff'}}
                  fileList={fileList}
                  beforeUpload={beforeUpload}
                  action={`${ROOT}/upload/filecos`}
                  onChange={this.handleChange}>
                  {fileList.length > 0 ? '' : uploadButton}
                </Upload>
              </div>
            </div>
            <div style={{marginTop: "30px", marginLeft: "210px"}}>
              <Button
                type="primary"
                size="large"
                style={{width: 120, borderRadius: '5px'}}
                onClick={()=>this.handleSubmit()}>
                提交
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
export default withRouter(App);
